/* Built In Imports */
/* External Imports */
import { Box, Icon, Show } from '@chakra-ui/react';

/* Internal Imports */
/* Components */

/* Services */
/* Styles */
export const SpeakerIcon = ({ width, height }) => {
  return (
    <Icon
      width={{ base: '23px', md: '36px' }}
      height={{ base: '23px', md: '36px' }}
      viewBox={{ base: '0 0 23px 23px', md: '0 0 36px 36px' }}
      fill="none"
    >
      <Show above="md">
        <path
          d="M28.6066 7.3934C31.3211 10.1079 33 13.8579 33 18C33 22.1421 31.3211 25.8921 28.6066 28.6066M23.8336 12.1664C25.3266 13.6593 26.25 15.7218 26.25 18C26.25 20.2782 25.3266 22.3407 23.8336 23.8336M3 12H9L18 7.125V28.875L9 24H3V12Z"
          stroke="black"
          strokeWidth="0.953488"
        />
      </Show>
      <Show below="md">
        <path
          d="M18.2758 4.72226C20.01 6.4565 21.0827 8.85233 21.0827 11.4987C21.0827 14.1451 20.01 16.5409 18.2758 18.2751M15.2264 7.77166C16.1802 8.72549 16.7702 10.0432 16.7702 11.4987C16.7702 12.9542 16.1802 14.2719 15.2264 15.2257M1.91602 7.66536H5.74935L11.4993 4.55078V18.4466L5.74935 15.332H1.91602V7.66536Z"
          stroke="black"
          strokeWidth="0.953488"
        />
      </Show>
    </Icon>
  );
};
export const VideoIcon = ({ width, height, pt }) => {
  return (
    <Box pt={pt || '18.81px'}>
      <Icon width={width || '24px'} height={height || 25} fill="none">
        <path
          d="M3.21191 5.67969H14.8962V19.3113H3.21191V5.67969Z"
          stroke="#032B43"
          strokeWidth="0.953488"
        />
        <path
          d="M14.8962 10.5481L20.7383 7.62706V17.3639L14.8962 14.4429V10.5481Z"
          stroke="#032B43"
          strokeWidth="0.953488"
        />
      </Icon>
    </Box>
  );
};
export const ArticleIcon = ({ width, height, pt }) => {
  return (
    <Box pt={pt || '18.81px'}>
      <Icon width={width || '24px'} height={height || 25} fill="none">
        <path
          d="M15.5788 12.4496V4.66016H2.9209V17.8049C2.9209 19.1493 4.01073 20.2391 5.35512 20.2391H18.013M15.5788 12.4496V17.8049C15.5788 19.1493 16.6687 20.2391 18.013 20.2391M15.5788 12.4496H20.4473V17.8049C20.4473 19.1493 19.3574 20.2391 18.013 20.2391M5.84196 16.3444H12.6578M6.81564 8.5549H11.6841V12.4496H6.81564V8.5549Z"
          stroke="#032B43"
          strokeWidth="0.953488"
        />
      </Icon>
    </Box>
  );
};
export const AudioIcon = ({ width, height, pt }) => {
  return (
    <Box pt={pt || '18.81px'}>
      <Icon
        width={width || '24px'}
        height={height || 25}
        viewBox={`0 0 24px 25px`}
        fill="none"
      >
        <path
          d="M10.0257 18.9085C10.0257 20.2529 8.71791 21.3428 7.10465 21.3428C5.4914 21.3428 4.18359 20.2529 4.18359 18.9085C4.18359 17.5642 5.4914 16.4743 7.10465 16.4743C8.71791 16.4743 10.0257 17.5642 10.0257 18.9085ZM10.0257 18.9085V6.73747L19.7626 3.81641V15.9875M19.7626 15.9875C19.7626 17.3319 18.4548 18.4217 16.8415 18.4217C15.2283 18.4217 13.9205 17.3319 13.9205 15.9875C13.9205 14.6431 15.2283 13.5533 16.8415 13.5533C18.4548 13.5533 19.7626 14.6431 19.7626 15.9875Z"
          stroke="black"
          strokeWidth="0.953488"
        />
      </Icon>
    </Box>
  );
};
